import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { GridActionsCell, GridActionsCellItem, type GridRenderCellParams } from '@mui/x-data-grid';

type HistorialCellProps = GridRenderCellParams & {
  onClick: (folio: string, partida: number) => void;
};

const HistorialCell = (props: HistorialCellProps) => {
  const { onClick, ...cellProps } = props;

  const folio = cellProps.row.folio ?? cellProps.row.folioInterno;

  return (
    <GridActionsCell {...cellProps}>
      <GridActionsCellItem
        icon={<AccessTimeIcon />}
        label="Historial"
        material={{ sx: { color: 'primary.main' } }}
        onClick={() => onClick(folio, cellProps.row.partida)}
      />
    </GridActionsCell>
  );
};

export default HistorialCell;
